import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { isEmpty } from 'lodash';

import './RecurringReview.scss';

import RecurringReviewFund from './RecurringReviewFund';
import BankSnapshot from '../../FundingSource/BankSnapshot/BankSnapshot';
import { getHasUserEmail } from '../../../redux/modules/user/PersonalInformation/personalInformation.selectors';
import {
  PAPERLESS_TERMS_MODAL,
  START_DATE_TOOL_TIP,
} from '../../../redux/modules/modals/modals.module';
import PaperlessOptIn from '../../Buy/BuyFlow/PaperlessOptIn/PaperlessOptIn';
import {
  BUY_TRANSACTION,
  isTransactionOneOf,
  SELL_TRANSACTION,
} from '../../../utils/transactions-util';
import iconHelp from '../../../assets/images/icon_help.svg';
import { isCustomerWebViewEnabled } from '../../../redux/modules/authentication/authentication.module.selectors';
import { isSalesforceRep } from '../../../redux/modules/authentication/authentication.module.selectors';

// const START_DATE_TOOLTIP = 'Automatic Buy programs are typically established the following business day, but can take up to three business days to be completed. Choosing an Automatic Buy date within 3 business days of today’s date may cause your first transaction to occur at the next instance of the chosen date.';

export class RecurringReview extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      displayPaperlessOption: isTransactionOneOf(
        BUY_TRANSACTION,
        SELL_TRANSACTION
      )
        ? null
        : false,
      paperlessTermsShown: false,
    };
    this.updatePaperlessChecked = this.updatePaperlessChecked.bind(this);
  }

  UNSAFE_componentWillMount() {
    const { paperless } = this.props.paperlessSetting;
    const { displayPaperlessOption } = this.state;

    if (displayPaperlessOption !== null || isEmpty(paperless)) {
      return;
    }
    const subscribed = this.isPaperlessSubscribed(paperless, 'MUTUAL_FUND');
    this.paperlessUpdate(subscribed);
  }

  updatePaperlessChecked(paperlessChecked) {
    const {
      actions: { openModal, updatePaperlessSetting },
    } = this.props;
    const { paperlessTermsShown } = this.state;

    updatePaperlessSetting(paperlessChecked);
    if (!paperlessTermsShown) {
      this.setState({
        paperlessTermsShown: true,
      });
      openModal(PAPERLESS_TERMS_MODAL);
    }
  }

  isPaperlessSubscribed(paperless, productType) {
    return paperless[0].subscriptions.some(
      (sub) => sub.productType === productType && sub.subscribedAll
    );
  }
  paperlessUpdate = (subscribed) => {
    this.setState({
      displayPaperlessOption: !subscribed,
    });
  };

  render() {
    const { displayPaperlessOption } = this.state;
    const {
      actions: { openModal },
      isSalesforceRep,
      customerWebViewEnabled,
      flattenedPurchasingFunds,
      hasUserEmail,
      paperlessSetting: { updatedPaperless },
      selectedBank,
    } = this.props;

    function showStartDateToolTip() {
      openModal(START_DATE_TOOL_TIP);
    }
    return (
      <div className="recurring-review-container">
        <div className="recurring-review-header-row">
          <div className="recurring-review-from-col">FROM:</div>
          <div className="recurring-review-header-funds-col">
            <div className="recurring-review-to-col">TO:</div>
            <div className="recurring-review-amount-col">AMOUNT:</div>
            <div className="recurring-review-frequency-col">FREQUENCY:</div>
            <div
              className={
                flattenedPurchasingFunds[0].startDate
                  ? 'recurring-review-start-date-col'
                  : 'recurring-review-hidden'
              }
            >
              <div>
                EST. START DATE{' '}
                <a onClick={showStartDateToolTip}>
                  <img
                    className="recurring-review-image"
                    alt="help"
                    src={iconHelp}
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="recurring-review-transaction-review-row">
          <div className="recurring-review-from-col recurring-review-bank-info-container">
            <div className="recurring-review-bank-info-limit">
              <div className="recurring-review-phone-label">From:</div>
              <BankSnapshot
                isRecurringReview
                isReview
                review
                bank={selectedBank}
              />
            </div>
          </div>
          <div className="recurring-review-funds-col">
            <div>
              {flattenedPurchasingFunds.map((fund, index) => (
                <RecurringReviewFund key={index} fund={fund} />
              ))}
            </div>
            {!(!customerWebViewEnabled && isSalesforceRep) && (
              <div className="recurring-review-electronic-transfer-text">
                <p>
                  For an electronic transfer (ACH) from your bank account, allow
                  2-3 business days from the trade date.
                </p>
              </div>
            )}
          </div>
        </div>
        {hasUserEmail &&
          displayPaperlessOption &&
          !(!customerWebViewEnabled && isSalesforceRep) && (
            <div className="recurring-review-recurring-paperless-container">
              <PaperlessOptIn
                openModal={openModal}
                paperlessChecked={updatedPaperless}
                updatePaperlessChecked={this.updatePaperlessChecked}
              />
            </div>
          )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isSalesforceRep: isSalesforceRep(state),
    customerWebViewEnabled: isCustomerWebViewEnabled(state),
    hasUserEmail: getHasUserEmail(state),
  };
};

export default compose(connect(mapStateToProps))(RecurringReview);
